import Game from "./engine/game";
import Interface from "./engine/interface";


//const player = spawnPlayer(90, 90);

//const stage = new Stage(World, player);

//
//const world = World.generate();

const game = Game.start();

//const updateSchedule = initializeUpdateSchedule(stage);

const ui = new Interface(game.stage);

document.addEventListener("keydown", (ev) => {
  ui.handleInput(ev);
});

document.addEventListener("ui.transition", ev => {
  ui.handleTransition(ev);
})

document.addEventListener("game.event", ev => {
  ui.handleGameEvent(ev);
});

window.addEventListener("resize", () => {
  ui.rescale();
});

function gameLoop() {
  game.update();
  ui.render();
  requestAnimationFrame(gameLoop);
}

window.addEventListener("load", () => {
  requestAnimationFrame(gameLoop);
});
